/**
* Civil Registration Abroad cluster — /civil-registration/*
* ทะเบียนราษฎรและเอกสารสถานะบุคคลจากต่างประเทศให้ใช้ในประเทศไทย
*/

export interface CivilRegService {
  slug: string;
  nameTh: string;
  nameEn: string;
  category: "birth" | "marriage" | "death" | "name" | "adoption";
  priceTHB: number;
  priceNote: string;
  turnaroundDays: number;
  keyDeliverables: string[];
  requiredDocs: string[];
  bestFor: string[];
  legalBasis: string;
}

export const CIVILREG_SERVICES: CivilRegService[] = [
  { slug: "birth-cert-abroad", nameTh: "จดทะเบียนเกิดต่างประเทศ + แจ้งไทย", nameEn: "Foreign Birth Registration + Thai Notification",
    category: "birth", priceTHB: 8500, priceNote: "สอบถามใบเสนอราคา · notify สถานทูตไทย + บันทึกในทะเบียนราษฎรไทย", turnaroundDays: 30,
    keyDeliverables: ["รวบรวม birth certificate + apostille/legalize", "แปลรับรองโดยกระทรวงต่างประเทศไทย", "ยื่น notification ที่สถานทูต/สถานกงสุลไทย", "บันทึกในทะเบียนคนเกิด (ท.ร.1)"],
    requiredDocs: ["birth certificate ต้นฉบับ + apostille", "passport บิดามารดา", "ทะเบียนสมรสบิดามารดา"],
    bestFor: ["บุตรของคนไทยที่เกิดต่างประเทศ", "การขอสัญชาติไทย"],
    legalBasis: "พ.ร.บ.การทะเบียนราษฎร 2534 + สัญชาติ 2508" },
  { slug: "thai-birth-cert", nameTh: "ขอสำเนาสูติบัตรและ affidavit", nameEn: "Thai Birth Certificate Copy + Affidavit",
  category: "birth", priceTHB: 3500, priceNote: "สอบถามค่าบริการ· สำเนา ท.ร.1 + คำแปลอังกฤษรับรอง", turnaroundDays: 7,
    keyDeliverables: ["ขอสำเนาต้นฉบับที่อำเภอ", "แปลรับรองอังกฤษโดยผู้แปลได้รับอนุญาต", "รับรองที่กระทรวงต่างประเทศ", "apostille (ถ้าต้องการใช้ต่างประเทศ)"],
    requiredDocs: ["บัตรประชาชน", "ทะเบียนบ้าน"],
    bestFor: ["ผู้ที่ต้องใช้เอกสารต่างประเทศ", "student visa", "งาน", "immigration"],
    legalBasis: "พ.ร.บ.การทะเบียนราษฎร + Hague Apostille Convention" },
  { slug: "marriage-abroad-record", nameTh: "บันทึกทะเบียนสมรสต่างประเทศในไทย", nameEn: "Foreign Marriage Registration in Thailand",
  category: "marriage", priceTHB: 12000, priceNote: "สอบถามค่าบริการ· แปล+รับรอง+บันทึก คร.22 ที่อำเภอ", turnaroundDays: 21,
    keyDeliverables: ["แปลใบสมรสรับรอง + apostille (ถ้าต้องการ)", "รับรองที่กระทรวงต่างประเทศไทย", "ยื่นบันทึกที่อำเภอ (คร.22)", "ขอสำเนาที่บันทึกแล้ว"],
    requiredDocs: ["ใบสมรสต่างประเทศ + apostille", "passport ทั้งคู่", "ทะเบียนบ้าน (ฝ่ายไทย)"],
    bestFor: ["คู่สมรสไทย-ต่างชาติที่จดที่ต่างประเทศ", "การใช้สิทธิสมรสในไทย"],
    legalBasis: "ป.พ.พ. บรรพ 5 + พ.ร.บ.การทะเบียนราษฎร" },
  { slug: "divorce-abroad-record", nameTh: "บันทึกการหย่าต่างประเทศในไทย", nameEn: "Foreign Divorce Registration",
  category: "marriage", priceTHB: 15000, priceNote: "สอบถามค่าบริการ· แปล+ตรวจสอบ+บันทึก คร.24", turnaroundDays: 30,
    keyDeliverables: ["ตรวจสอบคำพิพากษาหย่าต่างประเทศ", "แปล + รับรอง + กงสุลไทย", "ยื่นบันทึก คร.24 ที่อำเภอ", "coordination กรณีต้องขอศาลไทยรับรอง"],
    requiredDocs: ["คำพิพากษาหย่า + apostille", "ทะเบียนสมรสเดิม", "passport"],
    bestFor: ["ผู้ที่หย่าที่ต่างประเทศ", "ต้องการสถานะโสดในไทย"],
    legalBasis: "ป.พ.พ. + พ.ร.บ.การทะเบียนราษฎร + พ.ร.บ.ว่าด้วยการขัดกันแห่งกฎหมาย" },
  { slug: "death-cert-abroad", nameTh: "บันทึกการตายต่างประเทศในไทย", nameEn: "Foreign Death Registration",
    category: "death", priceTHB: 10000, priceNote: "สอบถามใบเสนอราคา · notify สถานทูต + บันทึก ท.ร.5", turnaroundDays: 21,
    keyDeliverables: ["รวบรวม death certificate + apostille", "แปลรับรอง", "notify สถานทูต + บันทึก ท.ร.5", "ประสานเรื่องมรดก (ถ้าต้องการ)"],
    requiredDocs: ["death certificate + apostille", "passport ผู้เสียชีวิต", "หลักฐานทายาท"],
    bestFor: ["ทายาทของคนไทยที่เสียชีวิตต่างประเทศ", "จัดการมรดก"],
    legalBasis: "พ.ร.บ.การทะเบียนราษฎร 2534" },
  { slug: "name-change-court", nameTh: "เปลี่ยนชื่อ-สกุล (Court Order)", nameEn: "Name Change (Court Petition)",
  category: "name", priceTHB: 18000, priceNote: "สอบถามค่าบริการ· ยื่นศาล + คำสั่ง + แจ้งอำเภอ", turnaroundDays: 90,
    keyDeliverables: ["ยกร่างคำร้องยื่นศาล", "ไต่สวน + คำสั่งศาล", "แจ้งอำเภอเปลี่ยนบัตรและทะเบียนบ้าน", "แจ้งหน่วยงานที่เกี่ยวข้อง"],
    requiredDocs: ["บัตรประชาชน", "ทะเบียนบ้าน", "เหตุผลการเปลี่ยน"],
    bestFor: ["ผู้ที่มีเหตุจำเป็นเปลี่ยนชื่อ-สกุล", "หลังหย่า/สมรส/สาเหตุอื่น"],
    legalBasis: "พ.ร.บ.ชื่อบุคคล 2505 + ป.วิ.แพ่ง" },
  { slug: "name-change-amphoe", nameTh: "เปลี่ยนชื่อที่อำเภอ (ง่ายๆ)", nameEn: "Simple Name Change (Amphoe)",
  category: "name", priceTHB: 5500, priceNote: "สอบถามค่าบริการ· consultation + เอกสารที่อำเภอ", turnaroundDays: 7,
    keyDeliverables: ["ตรวจสอบชื่อว่าเปลี่ยนได้ตามระเบียบ", "กรอกแบบ ช.1 ที่อำเภอ", "รับใบเปลี่ยนชื่อและออกบัตรใหม่", "แจ้งธนาคาร+หน่วยงาน"],
    requiredDocs: ["บัตรประชาชน", "ทะเบียนบ้าน"],
    bestFor: ["บุคคลทั่วไปที่ต้องการเปลี่ยนชื่อ"],
    legalBasis: "พ.ร.บ.ชื่อบุคคล 2505" },
  { slug: "surname-marriage", nameTh: "เปลี่ยนนามสกุลตามคู่สมรส", nameEn: "Surname Change After Marriage",
  category: "name", priceTHB: 3500, priceNote: "สอบถามค่าบริการ· service ที่อำเภอ + แจ้งทุกหน่วยงาน", turnaroundDays: 5,
    keyDeliverables: ["ยื่นเปลี่ยนที่อำเภอ", "ออกบัตรประชาชนใหม่", "แก้ทะเบียนบ้าน + passport", "แจ้งธนาคาร ประกัน กรมที่ดิน"],
    requiredDocs: ["ทะเบียนสมรส", "บัตรประชาชน"],
    bestFor: ["คู่สมรสใหม่", "คนที่หย่าและต้องการกลับใช้นามสกุลเดิม"],
    legalBasis: "พ.ร.บ.ชื่อบุคคล 2548 + ป.พ.พ. บรรพ 5" },
  { slug: "adoption-domestic", nameTh: "รับบุตรบุญธรรม (Domestic Adoption)", nameEn: "Domestic Adoption",
  category: "adoption", priceTHB: 55000, priceNote: "สอบถามค่าบริการ· court process 6-12 เดือน", turnaroundDays: 270,
    keyDeliverables: ["ตรวจคุณสมบัติผู้รับบุตรบุญธรรม", "ประสานศูนย์สวัสดิการเด็ก", "ยื่นคำร้องศาล + ไต่สวน", "จดทะเบียน + ออกใบใหม่"],
    requiredDocs: ["บัตรประชาชนผู้รับ", "ใบรับรองแพทย์", "ประวัติอาชญากรรม", "รายได้และที่อยู่"],
    bestFor: ["คู่สมรสที่ต้องการรับบุตรบุญธรรม"],
    legalBasis: "ป.พ.พ. บรรพ 5 + พ.ร.บ.การรับเด็กเป็นบุตรบุญธรรม 2522" },
  { slug: "adoption-intercountry", nameTh: "รับบุตรบุญธรรมต่างชาติ (Inter-country)", nameEn: "Inter-country Adoption",
  category: "adoption", priceTHB: 150000, priceNote: "สอบถามค่าบริการ· Hague Convention + ประสาน 2 ประเทศ", turnaroundDays: 540,
    keyDeliverables: ["Hague Convention compliance", "coordination home country agency", "ยื่นกรมพัฒนาสังคมและสวัสดิการ", "ศาลไทย + apostille + ย้ายต่างประเทศ"],
    requiredDocs: ["home study report", "police check + medical", "financial capability"],
    bestFor: ["ครอบครัวต่างชาติที่ต้องการรับเด็กไทย"],
    legalBasis: "Hague Adoption Convention 1993 + พ.ร.บ.รับเด็กเป็นบุตรบุญธรรม" },
  { slug: "legitimation", nameTh: "จดทะเบียนรับรองบุตร (Legitimation)", nameEn: "Child Legitimation",
  category: "birth", priceTHB: 8500, priceNote: "สอบถามค่าบริการ· จดที่อำเภอหรือศาล", turnaroundDays: 30,
    keyDeliverables: ["ประเมินวิธีจด (อำเภอ / ศาล)", "DNA test (ถ้าจำเป็น)", "ยื่นเอกสาร + จดทะเบียน", "แก้สูติบัตรเพิ่มบิดา"],
    requiredDocs: ["สูติบัตรบุตร", "บัตรประชาชนบิดา", "ความยินยอมมารดา (ถ้ามี)"],
    bestFor: ["บิดาที่ต้องการรับรองบุตรนอกสมรส"],
    legalBasis: "ป.พ.พ. มาตรา 1547-1560" },
  { slug: "guardianship", nameTh: "ผู้ปกครองตามกฎหมาย (Legal Guardianship)", nameEn: "Legal Guardianship",
  category: "adoption", priceTHB: 35000, priceNote: "สอบถามค่าบริการ· court petition + คำสั่ง", turnaroundDays: 90,
    keyDeliverables: ["ยื่นคำร้องขอเป็นผู้ปกครอง", "ไต่สวนพยาน + คำสั่งศาล", "จดทะเบียนที่อำเภอ", "รายงานประจำปีต่อศาล"],
    requiredDocs: ["บัตรประชาชนผู้ขอ", "สูติบัตรผู้เยาว์", "ความจำเป็น"],
    bestFor: ["ญาติที่ต้องดูแลผู้เยาว์กำพร้า", "หลังบิดามารดาเสียชีวิต"],
    legalBasis: "ป.พ.พ. มาตรา 1585-1598/10" },
];

export const CIVILREG_CATEGORIES = [
  { id: "birth", nameTh: "สูติบัตรและการเกิด", nameEn: "Birth" },
  { id: "marriage", nameTh: "สมรส-หย่า", nameEn: "Marriage & Divorce" },
  { id: "death", nameTh: "มรณะบัตร", nameEn: "Death" },
  { id: "name", nameTh: "เปลี่ยนชื่อ-สกุล", nameEn: "Name Change" },
  { id: "adoption", nameTh: "รับบุตรบุญธรรม-ผู้ปกครอง", nameEn: "Adoption & Guardianship" },
] as const;

export interface CivilRegCountry {
  slug: string;
  nameTh: string;
  nameEn: string;
  notes: string;
}

export const CIVILREG_COUNTRIES: CivilRegCountry[] = [
  { slug: "usa", nameTh: "สหรัฐอเมริกา", nameEn: "United States", notes: "apostille ผ่าน US Secretary of State; แปล+รับรองที่กระทรวงต่างประเทศไทย" },
  { slug: "uk", nameTh: "สหราชอาณาจักร", nameEn: "United Kingdom", notes: "apostille ที่ FCDO London; ใช้ได้กับไทยโดยตรงเนื่องจากอนุสัญญา Hague จะมีผลกับไทย 28 กุมภาพันธ์ 2570" },
  { slug: "australia", nameTh: "ออสเตรเลีย", nameEn: "Australia", notes: "apostille ผ่าน DFAT; NAATI translation ที่ยอมรับใน AU" },
  { slug: "germany", nameTh: "เยอรมนี", nameEn: "Germany", notes: "apostille ที่ Landesregierung; สถานทูตเยอรมันในกรุงเทพให้รับรองอีกชั้น" },
  { slug: "france", nameTh: "ฝรั่งเศส", nameEn: "France", notes: "apostille ผ่าน Cour d'appel; แปลรับรอง Traducteur Assermenté" },
  { slug: "japan", nameTh: "ญี่ปุ่น", nameEn: "Japan", notes: "apostille ที่ MOFA Japan; แปลรับรองผ่านสถานทูตไทยในโตเกียว" },
  { slug: "china", nameTh: "จีน", nameEn: "China", notes: "จีน เข้า Hague ต.ค. 2023 ใช้ apostille แทน legalization ได้แล้ว" },
  { slug: "singapore", nameTh: "สิงคโปร์", nameEn: "Singapore", notes: "apostille ผ่าน SAL; ใช้ได้โดยตรงในไทย" },
  { slug: "vietnam", nameTh: "เวียดนาม", nameEn: "Vietnam", notes: "ยังไม่เข้า Hague — ต้อง legalization ผ่านสถานทูตไทยในฮานอย" },
  { slug: "laos", nameTh: "ลาว", nameEn: "Laos", notes: "consular legalization ผ่านสถานทูตไทยในเวียงจันทน์" },
];
